export { default } from "./ResourcePageSchoolPicker";
export type { School } from "./ResourcePageSchoolPicker";
